export enum AddJobStepsEnum {
    Step1 = "stepOne",
    Step2 = "stepTwo",
    Step3 = "stepThree",
    Exit = "Exit",
    Finish = "Finish",
}
